
import TrackerAPI from 'api/TrackerAPI'

const LOCAL_STATE_KEY = 'tracker_state'
const STORAGE_KEY = 'tracker_unsynced_'

const makeStorageKey = i => STORAGE_KEY + (i/10000).toFixed(4).toString().replace('.', '')


const Actions = {
  CLOCK_ON  : 'clockOn',
  CLOCK_OFF : 'clockOff',
  UPDATE    : 'update'
}

class StorageService {

  getFirstFreeIndex() {
    let i = 1
    while (window.localStorage.getItem(makeStorageKey(i)) !== null) i++;
    return i
  }

  storeAction(action, params) {
    const i = this.getFirstFreeIndex()
    window.localStorage.setItem(makeStorageKey(i), JSON.stringify({ timestamp: (new Date()).toISOString(), action, params }))
  }

  getActions() {
    const actions = []
    let thisAction = null
    let i = 1
    while (thisAction = window.localStorage.getItem(makeStorageKey(i))) {
      actions.push(JSON.parse(thisAction))
      ++i
    }
    return actions
  }

  clearActions() {
    const keys = Object.keys(window.localStorage).filter(key => key.startsWith(STORAGE_KEY))
    for (let k of keys) {
      window.localStorage.removeItem(k)
    }
  }

  setState(diff) {
    var state = JSON.parse(window.localStorage.getItem(LOCAL_STATE_KEY) || '{}')
    state = { ...state, ...diff }
    window.localStorage.setItem(LOCAL_STATE_KEY, JSON.stringify(state))
  }

  getState() {
    const st = window.localStorage.getItem(LOCAL_STATE_KEY)
    return (st && JSON.parse(st)) || {}
  }
}

const storage = new StorageService()

const initialState = {
  session : null,

  truck_overnight: false,
  washing: false,
}

class TrackerService {

  async init() {
    for (let state = storage.getState();state;) return state
    storage.setState(initialState)
    return initialState
  }

  async getActiveEntry() {
    if (this.syncing) {
      return new Promise(resolve => setTimeout(async () => resolve(await this.getActiveEntry(), 500)))
    }
    let {status, response} = await TrackerAPI.getActiveEntry()
    if (status >= 200 && status < 300) {
      
      const transformActiveEntryIn = response => {
        const e = { ...response }
        delete e['allowances']
        e.truck_overnight = response.allowances.truck_overnight 
        e.washing = response.allowances.washing
        return e
      }

      const state = (response && Object.keys(response).length > 0) ? transformActiveEntryIn(response) : initialState
      storage.setState(state)
      return state
    }
    return storage.getState()
  }

  turnClockOn(time, lat, lng) {
    const diff = {
      session : {
        start_time: time,
        start_lat: lat,
        start_lng: lng,
        break: 0
      },
      truck_overnight: false,
      clock_on: true,
    }
    storage.setState(diff)
    this.safeDo(Actions.CLOCK_ON, { time, lat, lng })
    return diff
  }

  turnClockOff(time, lat, lng, Break) {
    const diff = {
      session: null,
      clock_on: false
    }
    storage.setState(diff)
    this.safeDo(Actions.CLOCK_OFF, { time, lat, lng, break: Break||0 })
    return diff
  }

  setTruckOvernight(enabled) {
    const diff = {
      truck_overnight: enabled 
    }
    storage.setState(diff)
    this.safeDo(Actions.UPDATE, { truck_overnight: enabled })
    return diff
  }

  setWashing(enabled) {
    const diff = { 
      washing: enabled 
    }
    storage.setState(diff)
    this.safeDo(Actions.UPDATE, { washing: enabled })
    return diff
  }

  setBreak(mins) {
    const diff = {
      session: {
        ...storage.getState().session,
        break: mins
      }
    }
    storage.setState(diff)
    this.safeDo(Actions.UPDATE, { break: mins })
    return diff
  }

  async safeDo(action, params) {
    if (this.syncing) {
      return setTimeout(() => this.safeDo(action, params), 500)
    }
    var failed = false
    
    if (window.navigator.onLine) {
      if (!await this.trySync()) {
        failed = true 
      } else {
        const {status, response} = await TrackerAPI[action](params)
        failed = (status < 200 || status > 299)
      }
    } else {
      failed = true 
    }
    if (failed) {
      storage.storeAction(action, params)
    }
  }

  enable() {
    window.addEventListener('online', this.trySync)
  }

  disable() {
    window.removeEventListener('online', this.trySync)
  }


  async trySync() {
    this.syncing = true
    
    try {
      const actions = storage.getActions()

      if (!actions || actions.length == 0) {
        this.syncing = false
        return true
      }

      const {status, response} = await TrackerAPI.sync(actions)

      if (status >= 200 && status < 300) {
        storage.clearActions()
        this.syncing = false 
        return true
      }
      this.syncing = false
      return false
    } catch (e) {
      this.syncing = false
      return false
    }
  }

}

const ts = new TrackerService()

export default ts 



// WEBPACK FOOTER //
// ./src/utils/trackerService.js